export default function Cross() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14.671" height="14.672" viewBox="0 0 14.671 14.672">
            <path id="Path_206" data-name="Path 206" d="M-73.43-79.606-63-90.034" transform="translate(75.552 92.157)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            <path id="Path_207" data-name="Path 207" d="M0,10.428,10.428,0" transform="translate(12.55 2.121) rotate(90)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
        </svg>
    )
}